import { render, staticRenderFns } from "./ActionSort.vue?vue&type=template&id=c6b2f030&scoped=true"
import script from "./ActionSort.vue?vue&type=script&lang=js"
export * from "./ActionSort.vue?vue&type=script&lang=js"
import style0 from "./ActionSort.vue?vue&type=style&index=0&id=c6b2f030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b2f030",
  null
  
)

export default component.exports